import { EyeIcon, EyeOffIcon } from '@heroicons/react/outline'
import React, { useState } from 'react'

export default function InputReveal({ onChange, error }) {
  const [show, setShow] = useState(false)
  return (
    <div className="relative">
      <input onChange={onChange} type={show ? 'text' : 'password'} className={error ? '!border-red-500' : ''} />
      <button onClick={() => setShow(!show)} type="button" className="absolute right-2 inset-y-0 text-gray-300 hover:text-white flex items-center">
        <span>{show ? <EyeOffIcon className="h-5 w-5" /> : <EyeIcon className="h-5 w-5" />}</span>
      </button>
    </div>
  )
}
